import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useReducer,
  useState
} from "react";
import { v4 as uuidv4 } from "uuid";
import { useMainHook } from "../../../hooks/main";
import { useNavigate, useParams } from "react-router-dom";
import { jsPDF } from "jspdf";
import { toast } from "react-toastify";
import Konva from "konva";
import api from "../../../services/api";
import { useSelection } from "./selection";
import { cloneDeep } from "lodash";
import { useToolbarEditor } from "./toolbarEditor";
import { useDiff } from "./diffDocuments";
interface HeaderEditorContextData {
  handleSaveNewVersion: () => void;
  handleSaveTemplate: (isAutoSave?: Boolean) => Promise<void>;
  handleGoHomePage: () => void;
  handleUndo: () => void;
  handleRedo: () => void;
  generatePDF: () => void;
  handleCreateNewProject: () => void;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  colorAvatar: string;
  setColorAvatar: React.Dispatch<React.SetStateAction<string>>;
}

const HeaderEditorContext = createContext<HeaderEditorContextData>(
  {} as HeaderEditorContextData
);

const HeaderEditorProvider: React.FC = ({ children }) => {
  const { objectScreen, currentTemplateInfo, goToDownload, setGoToDownload } =
    useMainHook();
  const {
    stageRef,
    clearStages,
    history,
    setHistory,
    documentName,
    setObjectScreen,
    addToHistory,
    handleModificationsInDocument,
    hasModifications,
    setHasModifications,
    handleOpenModalBlockFuncionalities
  } = useMainHook();

  const navigator = useNavigate();
  const [loading, setLoading] = useState(false);
  const handleSaveNewVersion = useCallback(() => {}, [objectScreen]);
  const { blockCommandKeyboard, setBlockCommandKeyboard } = useToolbarEditor();
  const [colorAvatar, setColorAvatar] = useState("");

  const { templateid } = useParams();

  const {
    selectedObject,
    currentMultipleSelection,
    setSelectedObject,
    setSelectedObjects,
    selectedObjects
  } = useSelection();

  const handleCreateNewProject = useCallback(async () => {
    const newProject = {
      template: {
        arrayOfPages: [{ pageNumber: 1, renderObjects: [] }]
      },
      title: `Novo documento`,
      description: `Novo documento`,
      is_automation: false
    };

    try {
      const request = await api.post("user-templates", newProject);
      const idNewProject = request.data.id;
      window.open(`/editor/my-template/${idNewProject}`, "_blank");
    } catch (err) {
      console.log(err?.response?.data, "error when create new project");
    }
  }, [objectScreen]);

  const myFunc = useCallback(
    (evt: KeyboardEvent) => {
      if (evt.key === "z" && evt.ctrlKey) {
        if (!blockCommandKeyboard) {
          handleUndo();
        }
      } else if (evt.key === "y" && evt.ctrlKey) {
        if (!blockCommandKeyboard) {
          handleRedo();
        }
      }
    },
    [history, blockCommandKeyboard]
  );

  useEffect(() => {
    window.addEventListener("keydown", myFunc);
    return () => window.removeEventListener("keydown", myFunc);
  }, [history, blockCommandKeyboard]);

  const handleSaveTemplate = useCallback(
    async (isAutoSave = false) => {
      setSelectedObject(null);
      setSelectedObjects([]);
      let stages = stageRef.current as Konva.Stage[];

      let formatedObjectToApi: any = [];

      const dataURL = stages[0].toDataURL();

      const blob = await (await fetch(dataURL)).blob();
      const file = new File([blob], "fileName.png", { type: "image/png" });

      let formData = new FormData();
      formData.append("thumbnail", file);

      try {
        setLoading(true);
        const fetchUploadPicture = await api.patch(
          `user-templates/thumbnail-upload/${currentTemplateInfo.current.id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        );
        console.log(fetchUploadPicture, "response id, thumb");
        setLoading(false);
      } catch (error) {
        console.log("error uploading thumbnail", error.response.data);
        setLoading(false);
      }

      stages.forEach((stage, index) => {
        let pageNumber = stage.attrs.id;

        let renderObjects = [];

        //layer     //objects
        stage.children[0].children.forEach((object, indexObject) => {
          let objectWithExtractedImagePropertie = null;

          if (object?.attrs?.image) {
            let { image, ...rest } = object.attrs;

            objectWithExtractedImagePropertie = rest;
          }

          renderObjects.push(
            objectWithExtractedImagePropertie
              ? objectWithExtractedImagePropertie
              : object.attrs
          );
        });

        formatedObjectToApi.push({
          pageNumber,
          renderObjects
        });
      });

      try {
        console.log(currentTemplateInfo.current.id, "id enviado");
        api.put("/user-templates", {
          user_template_id: currentTemplateInfo.current.id,
          template: {
            arrayOfPages: formatedObjectToApi
          },
          title: documentName.current
            ? documentName.current
            : "Documento sem nome"
        });

        if (isAutoSave) {
          console.log("");
        } else {
          toast.success("Template salvo com sucesso!");
        }
      } catch (error) {
        console.log("Error trying to save user template " + error);
      }
    },
    [
      stageRef,
      currentTemplateInfo,
      documentName,
      selectedObject,
      selectedObjects
    ]
  );

  const generatePDF = useCallback(async () => {
    //verify changes for block download with marks of editions
    let changes = false;

    objectScreen.forEach((page, index) => {
      page.renderObjects.forEach((renderedObject, index) => {
        if (renderedObject.text && !changes) {
          if (renderedObject.isModify) {
            changes = true;
          } else {
            changes = false;
          }
        }
      });
    });

    if (changes) {
      //if have changes pending then open modal to
      //user resolve conflicts of texts before
      //that do download of document

      handleOpenModalBlockFuncionalities("download");
    } else {
      //if don`t have modifications in document
      //let him do download
      setGoToDownload(true);
      const beforeState = cloneDeep(objectScreen);

      toast.success("Preparando o seu download...");

      setTimeout(() => {
        let myDoc = new jsPDF("p", "px", "a4", true);
        stageRef.current.forEach((page, index) => {
          const data_url = page.toDataURL({
            orientation: "p",
            unit: "mm",
            format: "a4",
            putOnlyUsedFonts: true,
            compress: true,
            pixelRatio: 2
          });
          let width = myDoc.internal.pageSize.getWidth();
          let height = myDoc.internal.pageSize.getHeight();
          let top_left_margin = 0;
          let PDF_Width = width + top_left_margin * 2;
          let PDF_Height = PDF_Width * 1.5 + top_left_margin * 2;
          if (index > 0) {
            myDoc.addPage();
            myDoc.addImage(data_url, "PNG", 0, 0, width, height);
          } else {
            myDoc.addImage(data_url, "PNG", 0, 0, width, height);
          }
        });
        myDoc.save(`${documentName.current}`);
        setGoToDownload(false);
        setObjectScreen(beforeState);
      }, 0);
    }
  }, [stageRef, hasModifications, objectScreen, goToDownload, selectedObject]);

  const handleGoHomePage = useCallback(() => {
    clearStages();
    navigator("/");
  }, []);

  const handleUndo = useCallback(() => {
    // cleaning mutipleSelection
    currentMultipleSelection.current.setNodes([]);

    if (history.currentStep === history.step.length) {
      addToHistory(true);
    }

    if (history.currentStep === 1) {
      setHistory(prevState => {
        setObjectScreen(prevState.step[1]);
        setObjectScreen(prevState.step[0]);

        return prevState;
      });
    }

    if (history.currentStep === 0) return;

    setHistory(prevState => {
      let cloneState = cloneDeep(prevState);

      cloneState.currentStep = cloneState.currentStep - 1;

      setObjectScreen(cloneState.step[cloneState.currentStep]);

      return cloneState;
    });
  }, [history, objectScreen]);

  const handleRedo = useCallback(() => {
    currentMultipleSelection.current.setNodes([]);
    if (history.currentStep + 1 === history.step.length) return;

    setHistory(prevState => {
      let cloneState = cloneDeep(prevState);

      cloneState.currentStep = cloneState.currentStep + 1;
      setObjectScreen(cloneState.step[cloneState.currentStep]);

      return cloneState;
    });
  }, [history, stageRef]);

  return (
    <HeaderEditorContext.Provider
      value={{
        handleSaveNewVersion,
        handleSaveTemplate,
        handleGoHomePage,
        generatePDF,
        handleUndo,
        handleRedo,
        handleCreateNewProject,
        loading,
        setLoading,
        colorAvatar,
        setColorAvatar
      }}
    >
      {children}
    </HeaderEditorContext.Provider>
  );
};

// creating hook

function useHeaderEditor(): HeaderEditorContextData {
  const context = useContext(HeaderEditorContext);

  if (!context) {
    throw new Error("useAuth must be used with an HeaderEditorProvider");
  }

  return context;
}

export { HeaderEditorProvider, useHeaderEditor };
